import script from "./Calendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=3de15834&lang=scss"

const __exports__ = script;

export default __exports__